import React from "react";

import Hero from "./Hero";
import Team from "./Team";

function PricingPage() {
  return (
    <>
      <Hero />
      <Team />
    </>
  );
}

export default PricingPage;